import { createFileRoute } from "@tanstack/react-router";

import CustomsTradePage from "@/features/dashboard/pages/customs-trade";

export const Route = createFileRoute("/(app)/dashboard/customs-trade")({
  component: () => <CustomsTradePage />,
});
